import React, { memo } from 'react';
import PropTypes from 'prop-types';
import GroupTable from 'components/UiKit/GroupTable';
import FarmRow from 'screens/Property/PropertiesLanding/components/FarmRow';
import CropZoneRow from 'screens/Property/PropertiesLanding/components/CropZoneRow';
import FieldRow from 'screens/Property/PropertiesLanding/components/FieldRow';

const renderCropZoneRow = (property, field, cropZone, geoJSONMap, handlers) => {
  const cropZoneGeoJSON = geoJSONMap.get(cropZone.id);
  return (
    <GroupTable.Row
      key={cropZone.id}
      onClick={() => handlers.handleSelectedCropZone(property, field, cropZone)}
      selectable={!!property.fields.length}
      selected={handlers.isCropZoneSelected(cropZone)}
    >
      <GroupTable.Cell>
        <CropZoneRow
          cropZone={cropZone}
          icon={cropZoneGeoJSON}
          fieldId={field.id}
          isEditable={false}
        />
      </GroupTable.Cell>
    </GroupTable.Row>
  );
};

const renderCropZones = (field, property, geoJSONMap, handlers) => {
  return field.cropzones.map(cropZone =>
    renderCropZoneRow(property, field, cropZone, geoJSONMap, handlers)
  );
};

const renderFieldRowGroup = (field, property, geoJSONMap, handlers) => {
  const fieldGeoJSON = geoJSONMap.get(field.id);
  return (
    <GroupTable.RowGroup
      key={field.id}
      arrowIcon
      canOpen={!!field.cropzones.length}
      onClick={() => handlers.handleSelectedField(property, field)}
      selectable={!!property.fields.length}
      selected={handlers.isFieldSelected(field)}
      indeterminate={handlers.isPropertyIndeterminate(field)}
    >
      <GroupTable.Row>
        <GroupTable.Cell>
          <FieldRow field={field} icon={fieldGeoJSON} />
        </GroupTable.Cell>
      </GroupTable.Row>
      {renderCropZones(field, property, geoJSONMap, handlers)}
    </GroupTable.RowGroup>
  );
};

const renderFields = (property, geoJSONMap, handlers) =>
  property.fields.map(field =>
    renderFieldRowGroup(field, property, geoJSONMap, handlers)
  );

const GroupByFarm = ({
  property,
  geoJSONMap,
  handleSelectedFarm,
  isFarmSelected,
  handleSelectedField,
  isFieldSelected,
  handleSelectedCropZone,
  isCropZoneSelected,
  isPropertyIndeterminate
}) => {
  const handlers = {
    handleSelectedField,
    isFieldSelected,
    handleSelectedCropZone,
    isCropZoneSelected,
    isPropertyIndeterminate
  };
  return (
    <GroupTable.RowGroup
      key={property.id}
      arrowIcon
      canOpen={!!property.fields.length}
      onClick={() => handleSelectedFarm(property)}
      selectable={!!property.fields.length}
      selected={isFarmSelected(property)}
      indeterminate={isPropertyIndeterminate(property)}
    >
      <GroupTable.Row>
        <GroupTable.Cell>
          <FarmRow farm={property} />
        </GroupTable.Cell>
      </GroupTable.Row>
      {renderFields(property, geoJSONMap, handlers)}
    </GroupTable.RowGroup>
  );
};
GroupByFarm.propTypes = {
  property: PropTypes.shape({
    id: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        cropzones: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string.isRequired
          })
        ).isRequired
      })
    ).isRequired
  }).isRequired,
  geoJSONMap: PropTypes.instanceOf(Map).isRequired,
  handleSelectedFarm: PropTypes.func.isRequired,
  isFarmSelected: PropTypes.func.isRequired,
  handleSelectedField: PropTypes.func.isRequired,
  isFieldSelected: PropTypes.func.isRequired,
  handleSelectedCropZone: PropTypes.func.isRequired,
  isCropZoneSelected: PropTypes.func.isRequired,
  isPropertyIndeterminate: PropTypes.func.isRequired
};
export default memo(GroupByFarm);
